// For all accordions on the page
function initAllAccordions() {
	// Usage requires this structure:
	/*
		<div class="js-accordion">
			<button type="button">Toggle Accordion State</button>
			<div>
				<p>Content goes inside of a div that is the next sibling of the button element. This container with class js-accordion should never have more than 2 direct child elements, the first being a button and the second being a container div.</p>
			</div>
		</div>
	*/
	// Options are included as classes on the container of the accordion;
	// js-start-open = loads as open instead of closed.
	// js-mobile-only = displays an accordion on mobile only, on desktop hides the accordion button and alwasy displays the accordion content.
	let didInit:boolean = false;
	const accordionContainers = document.querySelectorAll(".js-accordion");
	if(accordionContainers) {
		accordionContainers.forEach((accordion:HTMLElement) => {
			let accordionButton:HTMLElement = accordion.querySelector(":scope > button");
			let accordionContent:HTMLElement = accordion.querySelector(":scope > div");

			if(accordionButton && accordionContent && !accordionButton.hasAttribute("aria-controls")) {
				// Set up the properties
				if(accordion.classList.contains("js-start-open")) {
					accordionButton.setAttribute("aria-expanded", "true");
					accordion.classList.add("expanded");
					vSlideToggle(accordionContent);
				} else {
					accordionButton.setAttribute("aria-expanded", "false");
				}
				let ran:number = Math.floor(Math.random() * 1000000000);
				accordionButton.setAttribute("aria-controls", "ac_" + ran);
				accordionButton.setAttribute("id", "ach_" + ran);
				accordionContent.setAttribute("id", "ac_" + ran);
				accordionContent.setAttribute("aria-labeledby", "ach_" + ran);

				// Attach click event
				accordionButton.addEventListener("click", function (event) {
					if(this.getAttribute("aria-expanded") == "false") {
						this.setAttribute("aria-expanded", "true");
					} else {
						this.setAttribute("aria-expanded", "false");
					}
					this.parentElement.classList.toggle("expanded");
					vSlideToggle(this.nextElementSibling);
				});

				// Handle js-mobile-only
				if (accordion.classList.contains("js-mobile-only")) {
					if (window.innerWidth > TABLETBREAK) {
						accordionContent.style.display = "block";
					}
					window.addEventListener("resize", function () {
						if (window.innerWidth >= TABLETBREAK) {
							accordionContent.style.display = "block";
						} else if (window.innerWidth < TABLETBREAK) {
							accordionContent.style.removeProperty("display");
						}
					});
				}

				didInit = true;
			}
		});
	}

	// Implement a basic return that just confirms if any accordions were initialized at all.
	return didInit;
}
initAllAccordions();

// For an individual accordion
function initAccordion(accordion:HTMLElement) {
	// Usage requires this structure:
	/*
		<div class="js-accordion">
			<button type="button">Toggle Accordion State</button>
			<div>
				<p>Content goes inside of a div that is the next sibling of the button element. This container with class js-accordion should never have more than 2 direct child elements, the first being a button and the second being a container div.</p>
			</div>
		</div>
	*/
	// Options are included as classes on the container of the accordion;
	// js-start-open = loads as open instead of closed.
	// js-mobile-only = displays an accordion on mobile only, on desktop hides the accordion button and alwasy displays the accordion content.
	let didInit:boolean = false;
	let accordionButton:HTMLElement = accordion.querySelector(":scope > button");
	let accordionContent:HTMLElement = accordion.querySelector(":scope > div");

	if(accordionButton && accordionContent && !accordionButton.hasAttribute("aria-controls")) {
		// Set up the properties
		accordionButton.setAttribute("aria-expanded", "false");
		let ran:number = Math.floor(Math.random() * 1000000000);
		accordionButton.setAttribute("aria-controls", "ac_" + ran);
		accordionButton.setAttribute("id", "ach_" + ran);
		accordionContent.setAttribute("id", "ac_" + ran);
		accordionContent.setAttribute("aria-labeledby", "ach_" + ran);

		// Attach click event
		accordionButton.addEventListener("click", function (event) {
			if(this.getAttribute("aria-expanded") == "false") {
				this.setAttribute("aria-expanded", "true");
			} else {
				this.setAttribute("aria-expanded", "false");
			}
			this.parentElement.classList.toggle("expanded");
			vSlideToggle(this.nextElementSibling);
		});

		// Handle js-mobile-only
		if (accordion.classList.contains("js-mobile-only")) {
			if (window.innerWidth > TABLETBREAK) {
				accordionContent.style.display = "block";
			}
			window.addEventListener("resize", function () {
				if (window.innerWidth >= TABLETBREAK) {
					accordionContent.style.display = "block";
				} else if (window.innerWidth < TABLETBREAK) {
					accordionContent.style.removeProperty("display");
				}
			});
		}

		// Dispatch the click now that this has been instantiated.
		let clickEvent = new Event('click', { bubbles: true, cancelable: false });
		accordionButton.dispatchEvent(clickEvent);

		didInit = true;
	}

	// Implement a basic return that just confirms if any accordions were initialized at all.
	return didInit;
}

// Include a fallback to init any accordion that is dynamically added by checking it at the time of click.
document.addEventListener("click", function (event) {
	const clickTarget = event.target as HTMLElement;
	let accordionButton:HTMLElement = clickTarget.closest("button");
	if(null !== accordionButton && accordionButton.parentElement.classList.contains("js-accordion") && !accordionButton.hasAttribute("aria-controls")) {
		initAccordion(accordionButton.parentElement);
	}
});